import { FilePickerResult, FileProviderItemType, SelectedFilesSource } from 'owa-filepicker';
import * as trace from 'owa-trace';
import type { FilePickerData } from '../schema';

export default function handleFilePickerResponse(
    result: FilePickerResult,
    onError?: () => void
): FilePickerData[] | null {
    if (!result || result.files.length === 0) {
        trace.errorThatWillCauseAlert('Please select a file');
        return null;
    }

    if (result.source !== SelectedFilesSource.ProviderFiles) {
        // This should never be hit, as the option should be hidden
        trace.trace.warn('local computer file picker is not yet supported');
        onError?.();
        return null;
    }

    // const file = <FileProviderItemViewState>result.files[0];
    const filesData: FilePickerData[] = [];
    result.files.forEach(file => {
        const providerType = file.model.ProviderType;
        filesData.push({
            filePickerLinkData: {
                fileName: file.name,
                mimeType: file.model.MimeType,
                isFolder: file.type === FileProviderItemType.Folder,
            },
            fileProvider: providerType,
            fileId: file.model.Id!,
            location: file.location,
            providerEndpointUrl: file.model.ProviderEndpointUrl!,
        });
    });

    return filesData;
}
